import { put, takeEvery } from 'redux-saga/effects';
import { fetchSamplesSuccess, fetchSamplesFailure } from 'redux/ai/actions';
import request from 'utils/request';
import urls from 'utils/config';
import AiTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { AI_BASE_URL } = urls || {};

function* fetchSampleQueries({ payload }) {
  const url = `${AI_BASE_URL}/AI-Process-Applicants/chat_ai?app_id=${payload.appId}&stage_id=${payload.stageId}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchSamplesSuccess(response?.raw));
  } else {
    networkErrorHandler(
      response?.statusCode,
      `Failed to Fetch Sample Queries: ${response.message}`
    );
    yield put(fetchSamplesFailure(response.message));
  }
}

export function* onFetchSampleQueries() {
  yield takeEvery(AiTypes.FETCH_SAMPLE_QUERIES_START, fetchSampleQueries);
}
